import React, { useState } from 'react';

const SelectHolidaysReport = ({ fetchReports, drivers = [] }) => {
    const [year, setYear] = useState(new Date().getFullYear().toString());
    const [driverId, setDriverId] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = () => {
        if (!year) {
            setError('Please select a year.');
            return;
        }

        setError('');
        fetchReports({ year: Number(year), driverId: driverId || null });
    };

    const sortedDrivers = [...drivers].sort((a, b) =>
        `${a.name || ''} ${a.surname || ''}`.localeCompare(`${b.name || ''} ${b.surname || ''}`)
    );

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            justifyContent: 'center',
            alignItems: 'center',
            margin: '20px auto',
            padding: '40px',
            width: '100%',
            border: '2px solid',
            borderRadius: '10px',
            minHeight: '290px',
        }}>
            
            <h2>Holidays Report</h2>
            <p style={{ textAlign: 'center', fontSize: '14px', color: '#666' }}>
                View the full overview or drill down into one driver's holidays
            </p>

            <select
                value={driverId}
                onChange={(event) => setDriverId(event.target.value)}
                style={{ padding: '8px', textAlign: 'center', width: '100%', maxWidth: '280px' }}
                aria-label="Holiday report driver"
            >
                <option value="">All users - overview</option>
                {sortedDrivers.map((driver) => (
                    <option key={driver.id} value={driver.id}>
                        {driver.name} {driver.surname}
                    </option>
                ))}
            </select>

            <select
                value={year}
                onChange={(event) => setYear(event.target.value)}
                style={{ padding: '8px', textAlign: 'center', width: '100%', maxWidth: '280px' }}
                aria-label="Holiday report year"
            >
                {Array.from({ length: 10 }, (_, index) => {
                    const optionYear = new Date().getFullYear() - index;
                    return (
                        <option key={optionYear} value={optionYear}>
                            {optionYear}
                        </option>
                    );
                })}
            </select>

            <button
                onClick={handleSubmit}
                style={{
                    padding: '10px 20px',
                    backgroundColor: '#007bff',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    fontSize: '16px',
                    fontWeight: 'bold'
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
            >
                Generate Report
            </button>

            {error && (
                <div style={{ color: 'red', marginTop: '10px' }}>
                    {error}
                </div>
            )}
        </div>
    );
};

export default SelectHolidaysReport;